import { Sparkles, X } from "lucide-react";
import { useAuth } from "@/lib/auth";

const STAGE_LABEL = {
  orientierung: "Orientierung (Anfänger)",
  struktur: "Struktur (Fortgeschritten)",
  optimierung: "Optimierung (Experte)",
};

/**
 * Hinweisbalken für aktive Neu-User-Simulation. Zeigt zusätzlich, welche der
 * drei Nutzergruppen gerade simuliert wird.
 */
export default function NewUserSimBanner() {
  const { simMode, simStage, exitSim, isAdmin, realUser } = useAuth();
  if (!simMode || !isAdmin) return null;
  const email = realUser?.email;
  const stageLabel = STAGE_LABEL[simStage] || STAGE_LABEL.orientierung;
  return (
    <div
      className="sticky top-0 z-40 flex items-center gap-3 border-b border-primary/40 bg-primary/15 px-4 py-2 text-sm backdrop-blur"
      data-testid="sim-banner"
    >
      <Sparkles className="h-4 w-4 text-primary shrink-0" strokeWidth={1.5} />
      <div className="flex-1 min-w-0">
        <span className="font-medium text-foreground">Simulation: {stageLabel}</span>
        <span className="text-muted-foreground ml-2 hidden sm:inline">
          Du siehst die Seite so, wie ein Nutzer dieser Gruppe sie erlebt. Reale Daten ({email}) bleiben unangetastet.
        </span>
      </div>
      <button
        type="button"
        onClick={exitSim}
        className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background/70 px-3 py-1 text-xs hover:bg-background transition-colors"
        data-testid="sim-banner-exit"
      >
        <X className="h-3.5 w-3.5" strokeWidth={1.75} /> Simulation beenden
      </button>
    </div>
  );
}
